export const isAuthenticated = () => {
    return !!localStorage.getItem('user');
};
  
export const getUser = () => {
    const user = localStorage.getItem('user');
    console.log('user:', user);
    if (!user) {
        return null;
    }
    try {
        return JSON.parse(user);
    } catch (e) {
        console.error('Error parsing user from localStorage', e);
        return null;
    }
};
export const login = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

// Merges fields (e.g. a freshly-uploaded avatar path) into the cached user
// object and notifies any mounted listeners (Layout's topbar) so they can
// re-render without requiring a fresh login.
export const updateUser = (partial) => {
  const current = getUser();
  if (!current) return;
  const updated = { ...current, ...partial };
  localStorage.setItem('user', JSON.stringify(updated));
  window.dispatchEvent(new Event('user-updated'));
  return updated;
};

export const logout = () => {
  localStorage.removeItem('user');
};
  